<template>
  <div class="sm-products-add-edit-container">
    <div class="product-form-step">
      <SMProductsFormStep
        ref="productFormStep"
        :value="data"
        :validations="{ data: $v.data }"
        :product-types="productTypes"
        :measure-units="measureUnits"
        @input="onFormInput"
      />
    </div>
    <SMProductsRightPanel :value="data" :saving="saving" @save="save" @goto-list="gotoList" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import required from "vuelidate/lib/validators/required";
import SMProductsFormStep from "@/pages/stock-management/sm-products/partials/SMProductsFormStep.vue";
import SMProductsRightPanel from "@/pages/stock-management/sm-products/partials/SMProductsRightPanel.vue";
import { errorMessage, successMessage } from "@/helpers/common";

export default {
  name: "ProductAddOrEditContent",
  components: {
    SMProductsFormStep,
    SMProductsRightPanel,
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data: { ...this.productData },
      productTypes: [],
      measureUnits: [],
      saving: false,
    };
  },
  watch: {
    productData: {
      deep: true,
      handler(newData) {
        this.data = { ...newData };
        if (this.$v) this.$v.$reset();
      },
    },
  },
  methods: {
    ...mapActions({
      createProduct: "smProducts/createSmProduct",
      updateProduct: "smProducts/updateSmProduct",
      getProductTypes: "smProductTypes/searchSmProductTypes",
      getMeasureUnits: "measureUnits/searchMeasureUnits",
    }),
    onFormInput(updatedData) {
      this.data = { ...updatedData };
    },
    async loadOptions() {
      try {
        const [productTypes, measureUnits] = await Promise.all([
          this.getProductTypes({}),
          this.getMeasureUnits({ enablePagination: 0 }),
        ]);
        this.productTypes = Array.isArray(productTypes) ? productTypes : Array.isArray(productTypes?.data) ? productTypes.data : [];
        this.measureUnits = Array.isArray(measureUnits) ? measureUnits : Array.isArray(measureUnits?.data) ? measureUnits.data : [];
      } catch (error) {
        errorMessage(this, this.$t("error_alert_text"), error);
      }
    },
    async save() {
      const errors = this.$refs.productFormStep.validate();
      if (errors.length) {
        errors.forEach((message) => errorMessage(this, message));
        return;
      }

      this.saving = true;
      try {
        const response = this.data.uuid ? await this.updateProduct(this.data) : await this.createProduct(this.data);
        if (response?.message) successMessage(this, response.message);
        this.$emit("onProductSaved", response?.data || response);
      } catch (error) {
        errorMessage(this, error?.response?.data?.message || this.$t("error_alert_text"), error);
      } finally {
        this.saving = false;
      }
    },
    gotoList() {
      this.$emit("onGotoListProduct");
    },
  },
  mounted() {
    this.loadOptions();
  },
  validations() {
    return {
      data: {
        name: { required },
        product_type: { required },
        measure_unit_id: { required },
      },
    };
  },
};
</script>

<style scoped>
.sm-products-add-edit-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.product-form-step {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding: 16px;
}
</style>